import React from 'react';
import { WavesIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy-deep py-16 px-6" data-id="element-113">
      <div className="max-w-6xl mx-auto" data-id="element-114">
        {/* Wave divider */}

        {/* Sail logomark — already-white SVG, plain img */}
        <div className="flex justify-center mb-6" data-id="element-115">
          <img src="https://cdn.magicpatterns.com/uploads/wAdPA7wgvdq7XrQn29qvhh/FCh_logo_White.svg" alt="Future Challenge logo" width="64" height="64" className="h-16 w-auto block" data-id="element-116" />
        </div>

        {/* Wordmark — clean re-exported SVG, white via filter */}
        <div className="flex justify-center mb-8" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/6ikzqbMg3YKiQTBTLZDAFn/FutureChallenge.svg" alt="FUTURE CHALLENGE" className="block h-6 md:h-8 w-auto opacity-90" style={{
          filter: 'brightness(0) invert(1)'
        }} data-id="element-118" />
        </div>

        {/* Copyright */}
        <div className="text-center text-white/60 text-sm" data-id="element-119">
          © 2026 Future Challenge · Soukromá akce
        </div>
      </div>
    </footer>;
}